// Cookie Consent Utility Functions

export const getCookieConsent = () => {
  return localStorage.getItem('cookieConsent');
};

export const getCookieConsentDate = () => {
  return localStorage.getItem('cookieConsentDate');
};

export const hasAcceptedAllCookies = () => {
  return getCookieConsent() === 'all';
};

export const hasAcceptedNecessaryCookies = () => {
  const consent = getCookieConsent();
  return consent === 'all' || consent === 'necessary';
};

export const hasRejectedAllCookies = () => {
  return getCookieConsent() === 'rejected';
};

export const canUseAnalytics = () => {
  const consent = getCookieConsent();
  if (consent === 'all') return true;
  if (consent === 'custom') {
    const preferences = JSON.parse(localStorage.getItem('cookiePreferences') || '{}');
    return preferences.analytics === true;
  }
  return false;
};

export const canUseMarketing = () => {
  const consent = getCookieConsent();
  if (consent === 'all') return true;
  if (consent === 'custom') {
    const preferences = JSON.parse(localStorage.getItem('cookiePreferences') || '{}');
    return preferences.marketing === true;
  }
  return false;
};

export const canUsePreferences = () => {
  const consent = getCookieConsent();
  if (consent === 'all') return true;
  if (consent === 'custom') {
    const preferences = JSON.parse(localStorage.getItem('cookiePreferences') || '{}');
    return preferences.preferences === true;
  }
  return false;
};

export const canUseEssential = () => {
  // Essential cookies are always allowed
  return true;
};

// Function to initialize analytics based on consent
export const initializeAnalytics = () => {
  if (canUseAnalytics()) {
    // Initialize Google Analytics, Facebook Pixel, etc.
    console.log('Analytics initialized - user has accepted all cookies');
    
    // Example: Google Analytics initialization
    // if (typeof window !== 'undefined' && window.gtag) {
    //   window.gtag('consent', 'update', {
    //     'analytics_storage': 'granted'
    //   });
    // }
  } else {
    console.log('Analytics disabled - user has not accepted all cookies');
  }
};

// Function to initialize marketing cookies based on consent
export const initializeMarketing = () => {
  if (canUseMarketing()) {
    // Initialize marketing pixels, retargeting, etc.
    console.log('Marketing cookies initialized - user has accepted all cookies');
    
    // Example: Facebook Pixel initialization
    // if (typeof window !== 'undefined' && window.fbq) {
    //   window.fbq('consent', 'grant');
    // }
  } else {
    console.log('Marketing cookies disabled - user has not accepted all cookies');
  }
};

// Function to save user preferences based on consent
export const saveUserPreferences = (preferences) => {
  if (canUsePreferences()) {
    // Save user preferences to localStorage or cookies
    localStorage.setItem('userPreferences', JSON.stringify(preferences));
    console.log('User preferences saved - user has accepted all cookies');
  } else {
    console.log('User preferences not saved - user has not accepted all cookies');
  }
};

// Function to clear all non-essential cookies
export const clearNonEssentialCookies = () => {
  if (hasRejectedAllCookies()) {
    // Clear analytics, marketing, and preference cookies
    // Keep only essential cookies
    console.log('Clearing non-essential cookies');
    
    // Example: Clear Google Analytics cookies
    // document.cookie.split(";").forEach(function(c) { 
    //   document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    // });
  }
};

// Function to update consent and reinitialize services
export const updateCookieConsent = (consentType) => {
  localStorage.setItem('cookieConsent', consentType);
  localStorage.setItem('cookieConsentDate', new Date().toISOString());
  
  if (consentType === 'all') {
    initializeAnalytics();
    initializeMarketing();
  } else if (consentType === 'necessary') {
    clearNonEssentialCookies();
  } else if (consentType === 'rejected') {
    clearNonEssentialCookies();
  }
}; 